export default {"src":"/_next/static/media/arrow-left-circle-fill.3188f72f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};